// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__1cPXf","bookingInfo":"TimeRange_bookingInfo__7DF-m","dateSection":"TimeRange_dateSection__3neTg"};